import Raven from "raven-js";

export default store => next => action => {
  if (process.env.NODE_ENV === "production") {
    Raven.captureBreadcrumb({
      type: "redux",
      data: {
        action
      }
    });
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/core/integrations/sentry/sentryMiddleware.js